import React from "react";
import {
  SmallPostCardBase,
  Title,
  Author,
  Metadata,
  Image,
  PostType,
  PostTypeIcon,
  TextWrapper,
  ImageContainer,
  SubjectLink,
} from "./small-post-card.styled";
import {
  ContentPostFragment,
  CustomQueriedResourcesPostsQuery,
} from "../../types/graphql";
import {
  contentPostReadTime,
  contentIconStyle,
  linkTo,
  getPublicationDate,
  getEditedDate,
} from "../../utils/contentUtils";
import { PostsByCategory } from "../../templates/content-hub/content-hub";
import * as FA from "../../styles/fontawesome";

interface ISmallPostCardProps {
  post: ContentPostFragment | PostsByCategory["posts"][number]["node"];
  hideAuthorName?: boolean | any | undefined;
}

const SmallPostCard = (props: ISmallPostCardProps) => {
  const doc = props.post;
  const post = props.post.data;
  const author = post?.author;
  const readTime = contentPostReadTime(doc);
  const publicationDate = getPublicationDate(doc);
  const editedDate = getEditedDate(doc);
  const articleDate =
    publicationDate == editedDate ? publicationDate : editedDate;
  const hideAuthorName = props.hideAuthorName;

  return (
    (post && (
      <SmallPostCardBase>
        <ImageContainer>
          {post.content_type && (
            <PostType>
              <PostTypeIcon css={contentIconStyle(post.content_type)} />
              {post.content_type}
            </PostType>
          )}
          <Image
            className="image"
            image={post.image?.gatsbyImageData || ""}
            alt={post.image?.alt || "Xometry Image"}
          />
        </ImageContainer>
        <TextWrapper>
          {/**
           * Not all uses of small post card will have slice data available,
           * which is required for readTime. Fallback to displaying
           * publication date in those scenarios.
           */}
          <SubjectLink to={linkTo(doc)}>
            {post.title && <Title>{post.title}</Title>}
          </SubjectLink>
          {author?.document &&
            "data" in author.document &&
            author?.document?.data.name &&
            !hideAuthorName && (
              <Author>By {author?.document?.data.name}</Author>
            )}
          <Metadata>
            {(post.content_type === "Article" && readTime && (
              <>
                <i css={FA.ClockSolid}></i>&nbsp;&nbsp;
                {contentPostReadTime(doc)}
              </>
            )) ||
              (post.content_type !== "Download" && <>{articleDate}</>)}
          </Metadata>
        </TextWrapper>
      </SmallPostCardBase>
    )) || <></>
  );
};

export default SmallPostCard;
